import { Component, Input, input, OnInit } from '@angular/core';

import { AvailabilityWidgetComponent } from '@valk-nx/storyblok/components/availability-widget/src/lib/availability-widget';
import { CarouselComponent } from '@valk-nx/storyblok/components/carousel/src/lib/carousel';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { Carousel } from '@valk-nx/storyblok-types/src/lib/types/storyblok.types';

@Component({
	selector: 'sb-carousel-with-availability-widget',
	templateUrl: './carousel-with-availability-widget.html',
	imports: [
		CarouselComponent,
		AvailabilityWidgetComponent,
		StoryblokDirective,
	],
})
export class CarouselWithAvailabilityWidgetComponent
	extends StoryblokRootDirective
	implements OnInit
{
	@Input() blocks: Carousel[] = [];
	@Input({ required: true }) hotelGUID!: string;
	hotelSlug = input<string | undefined>(undefined);
	openInNewTab = input<boolean>(false);

	carousel!: Carousel;

	ngOnInit() {
		this.carousel = this.blocks.find((x) => x.component === 'carousel');
	}
}
